import { Keyboard, KeyboardInfo } from '@capacitor/keyboard'
import { Capacitor } from '@capacitor/core'
import { insets } from './useLayout'

const height = ref(0)
const isKeyboardActive = ref(false)
export const isNoInsets = ref(false)

const isAvailable = ref(false)

export const getKeyboard = () => {

  return {
    kHeight: computed(() => height.value),
    isKeyboardActive: computed(() => isKeyboardActive.value)
  }
}

export const initKeyboard = () => {

  const onShow = (info: KeyboardInfo) => {
    isAvailable.value = true

    height.value = info.keyboardHeight
    
    isKeyboardActive.value = true
    isNoInsets.value = true
  }

  const onHide = () => {
    height.value = 0
    isKeyboardActive.value = false
    isNoInsets.value = false
  }

  if (Capacitor.isPluginAvailable('Keyboard') && Capacitor.isNativePlatform()) {
    Keyboard.addListener('keyboardWillShow', info => onShow(info))
    Keyboard.addListener('keyboardDidShow', info => onShow(info))

    Keyboard.addListener('keyboardWillHide', onHide)
    // Keyboard.addListener('keyboardDidHide', onHide)
  }

  return { onShow, onHide }
}